export const GET_ARTIST_PRESETS = '[Artist Presets] Get artist presets';
export const GET_ARTIST_PRESETS_SUCCESS =
  '[Artist Presets] Get artist presets Success';
export const GET_ARTIST_PRESETS_ERROR =
  '[Artist Presets] Get artist presets Error';

export const UPDATE_ARTIST_PRESETS = '[Artist Presets] Update artist presets';
export const UPDATE_ARTIST_PRESETS_SUCCESS =
  '[Artist Presets] Update artist presets Success';
export const UPDATE_ARTIST_PRESETS_ERROR =
  '[Artist Presets] Update artist presets Error';

export const UPDATE_ARTIST_PRESETS_FIELD =
  '[Artist Presets] Update artist presets field';
